import { formatCurrency } from '@/features/products/utils'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

interface Verba {
  verba: string
  valor: number
}

interface PDFParams {
  cnpj: string
  periodoInicial: string
  periodoFinal: string
  verbas: Verba[]
}

function formatCNPJ(cnpj: string): string {
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}

function formatPeriodo(periodo: string): string {
  if (periodo.length === 6) {
    const mes = periodo.slice(0, 2)
    const ano = periodo.slice(2)
    return `${mes}/${ano}`
  }
  return periodo
}

export function handleDownloadPDFVerbas({
  cnpj,
  nomeEmpresa,
  periodoInicial,
  periodoFinal,
  verbas
}: PDFParams & { nomeEmpresa: string }) {
  const doc = new jsPDF()

  const cnpjFormatado = formatCNPJ(cnpj)
  const periodoInicialFormatado = formatPeriodo(periodoInicial)
  const periodoFinalFormatado = formatPeriodo(periodoFinal)
  const total = verbas.reduce((sum, verba) => sum + verba.valor, 0)

  // Cabeçalho
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(16)
  doc.text('DIAGNÓSTICO PREVIDENCIÁRIO - INSS', 14, 20)

  doc.setFontSize(12)
  doc.text(`${nomeEmpresa}`, 14, 30)

  doc.setFont('helvetica', 'normal')
  doc.text(`CNPJ: ${cnpjFormatado}`, 14, 40)
  doc.text(`Calculado em: ${new Date().toLocaleDateString('pt-BR')}`, 14, 50)
  doc.text(`Período de apuração: ${periodoInicialFormatado} - ${periodoFinalFormatado}`, 14, 60)

  doc.setFillColor(255, 204, 0)
  doc.rect(14, 65, 180, 10, 'F')
  doc.setTextColor(0, 0, 0)
  doc.text(`TOTAL DO CRÉDITO A SER COMPENSADO R$ ${formatCurrency(total)}`, 16, 72)

  const tableData = verbas.map(({ verba, valor }) => [verba, formatCurrency(valor)])

  autoTable(doc, {
    startY: 80,
    head: [['Verba', 'Valor']],
    body: tableData,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [200, 200, 200] },
    margin: { left: 14, right: 14 }
  })

  doc.save(`${nomeEmpresa}_diagnostico_previdenciario.pdf`)
}
